import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { ModuleWithProviders } from '@angular/core';
import { CanActivateViaAuthGuard } from '../services/authguard.service';
import { SystemDetailsComponent } from './systemDetailsRetriever/system-details-retriever.component';
import { SystemTypeRegistrationComponent } from './systemTypeManagement/system-type-registration.component';
import { AccessManagementComponent } from './accessManagement/access-management.component';
import { SentienceDeviceManagerComponent } from './sentienceDeviceManager/sentience-device-manager.component';
import { PortalAdmin } from './portalAdmin/portaladmin.component';
import { ModelTypeRegistrationComponent } from "./modelTypeRegistration/model-type-registration.component";
import { AnnotationStreamManagementComponent } from './annotationStreamManagement/annotation-stream-management.component';
import { SystemHealthComponent } from './systemHealthRetriever/system-health-retriever.component';
import { CustomApplicationCreatorComponent } from "./customapplicationcreation/custom-application-creation.component";
import { SystemSeviceManagementComponent } from './SystemServicesManager/system-service.component';
import { UserManagementComponent } from './userManagement/user-management.component';
import { OnboardingUserComponent } from './onboardingUserForgerock/onboard-user.component';
import { TenantDetailsRemoverComponent } from './tenant-details-remover/tenant-details-remover.component';
import { ForgerockUriManagementComponent } from "./forgerockUriManagement/forgerock-uri-management.component";
import { DeviceCACertificateManagementComponent } from "./DeviceCACertificateManagement/manage-device-ca-certificates-component";
import { finegrainedComponent } from "./FineGrainedAuthorization/finegrained.component";
import { AnnotationStreamManagementComponentV2 } from "./annotationStreamManagementV2/annotation-stream-management.component"

const mainRoutes: Routes = [
    {
        path: 'main',
        component: MainComponent,
        canActivate: [CanActivateViaAuthGuard],
        children: [
            {
                path: 'RetrieveSystemDetails',
                component: SystemDetailsComponent
            },
            {
                path: 'SystemTypeManagement',
                component: SystemTypeRegistrationComponent
            },
            {
                path: 'accessmanagement',
                component: AccessManagementComponent
            },
            {
                path: 'SentienceDeviceManager',
                component: SentienceDeviceManagerComponent
            },
            {
                path: 'PortalAdmin',
                component: PortalAdmin
            },
            {
                path: 'model-type-registration',
                component: ModelTypeRegistrationComponent
            },
            {
                path: 'tenant-details-remover',
                component: TenantDetailsRemoverComponent
            },
            {
                path: 'AnnotationStreamManagement',
                component: AnnotationStreamManagementComponent
            },
            {
                path: 'AnnotationStreamManagementV2',
                component: AnnotationStreamManagementComponentV2
            },
            {
                path: 'CustomApplicationCreation',
                component: CustomApplicationCreatorComponent
            },
            {
                path: 'RetrieveSystemHealth',
                component: SystemHealthComponent
            },
            {
                path: 'system-service-manager',
                component: SystemSeviceManagementComponent
            },
            {
                path: 'UserManagement',
                component: UserManagementComponent
            },
            {
                path: 'OnboardingUserForgerock',
                component: OnboardingUserComponent
            },
            {
                path: 'forgerock-uri-updation',
                component: ForgerockUriManagementComponent
            },
            {
                path: 'manage-device-ca-certificates',
                component: DeviceCACertificateManagementComponent
            },
            {
                path: 'FineGrainedAuthManagement',
                component: finegrainedComponent
            },
            {
                path: '',
                redirectTo: 'RetrieveSystemDetails', pathMatch: 'full'
            }
            
        ]

    }
];

export const appRoutingProviders: any[] = [];
export const mainRouting: ModuleWithProviders = RouterModule.forChild(mainRoutes);


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/main.routes.ts
 **/